export default __webpack_public_path__ + "static/media/logo.d5a5c8e1.png";